import { ScreensManager } from '@micromag/core';
import article from '@micromag/screen-article';
import audio from '@micromag/screen-audio';
import contribution from '@micromag/screen-contribution';
import conversation from '@micromag/screen-conversation';
import gallery from '@micromag/screen-gallery';
import galleryFeed from '@micromag/screen-gallery-feed';
import image from '@micromag/screen-image';
import keypad from '@micromag/screen-keypad';
import map from '@micromag/screen-map';
import quiz from '@micromag/screen-quiz';
import quote from '@micromag/screen-quote';
import ranking from '@micromag/screen-ranking';
import share from '@micromag/screen-share';
import slideshow from '@micromag/screen-slideshow';
import survey from '@micromag/screen-survey';
import text from '@micromag/screen-text';
import timeline from '@micromag/screen-timeline';
import title from '@micromag/screen-title';
import urbaniaArticle, { definitionCard } from '@micromag/screen-urbania-article';
import urbaniaHoroscope from '@micromag/screen-urbania-horoscope';
import urbaniaRecommendation from '@micromag/screen-urbania-recommendation';
import urbaniaTrivia from '@micromag/screen-urbania-trivia';
import video from '@micromag/screen-video';
import video360 from '@micromag/screen-video-360';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React from 'react';
import { ScreensProvider as ScreensProvider$1 } from '@micromag/core/contexts';

var manager$1 = new ScreensManager();
manager$1.addDefinition(article);
manager$1.addDefinition(audio);
manager$1.addDefinition(contribution);
manager$1.addDefinition(conversation);
manager$1.addDefinition(gallery);
manager$1.addDefinition(galleryFeed);
manager$1.addDefinition(keypad);
manager$1.addDefinition(image);
manager$1.addDefinition(map);
manager$1.addDefinition(quiz);
manager$1.addDefinition(quote);
manager$1.addDefinition(ranking);
manager$1.addDefinition(share);
manager$1.addDefinition(survey);
manager$1.addDefinition(text);
manager$1.addDefinition(timeline);
manager$1.addDefinition(title);
manager$1.addDefinition(video);
manager$1.addDefinition(video360);
manager$1.addDefinition(slideshow);
manager$1.addDefinition(urbaniaArticle);
manager$1.addDefinition(definitionCard);
manager$1.addDefinition(urbaniaTrivia);
manager$1.addDefinition(urbaniaRecommendation);
manager$1.addDefinition(urbaniaHoroscope);

var manager = new ScreensManager();
manager.merge(manager$1);

var _excluded = ["children"];
var propTypes = {
  children: PropTypes.node.isRequired
};
var defaultProps = {};
var ScreensProvider = function ScreensProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ScreensProvider$1, Object.assign({}, props, {
    manager: manager
  }), children);
};
ScreensProvider.propTypes = propTypes;
ScreensProvider.defaultProps = defaultProps;

export { ScreensProvider, manager as default };
